import React, { useContext } from 'react';
import { UIContext } from '../contexts';
import DefaultView from './DefaultView';
import DetailsView from './DetailsView';

const ViewRouter = () => {
	const { activeView } = useContext(UIContext);

	if (activeView === 'detail') {
		return <DetailsView />;
	}

	return <DefaultView />;
};

export default ViewRouter;
